<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-poll"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="service.name"
                    filled
                    label="Name"
                    placeholder="Enter service name"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="service.description"
                    filled
                    label="Description"
                    placeholder="Enter service description"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-file-input
                    label="Ảnh "
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    v-model="image"
                    @change="uploadImg"
                ></v-file-input>
                <div v-if="display_image">
                  <v-img
                      :src="display_image"
                      aspect-ratio="1.7"
                      contain
                      width="50"
                  ></v-img>
                </div>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="service.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên service"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="service.description_vi"
                    filled
                    label="Mô tả"
                    placeholder="Nhập mô tả service"
                ></v-textarea>
              </v-col>
            </v-col>
          </v-row>
          <v-col cols="12" class="text-center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {UPLOAD_IMAGE} from "@/store/modules/field_project";
import {SAVE_SERVICE} from "@/store/modules/service";

export default {
  name: "Addnew_service",
  data() {
    return {
      page: "Thêm service",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách service",
          disabled: true,
        },
        {
          text: "Thêm service",
          disabled: false,
        },
      ],


      image: null,
      display_image: '',

      service: {
        name: '',
        name_vi: '',
        description: '',
        description_vi: '',
        active: 0,
        photo_url: ''
      }
    }
  },
  methods: {

    uploadImg(e) {
      if (e) {
        this.display_image = URL.createObjectURL(e)
      }
      this.$forceUpdate()
    },

    async save() {
      let formDateAvatar = new FormData();
      formDateAvatar.append("upload", this.image);
      formDateAvatar.append("type", "ckeditor");
      formDateAvatar.append("position_type", "1");
      await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
            if (data.data.status == 1) {
              this.service.photo_url = data.data.data[0].path
            }
          }
      )
      let data = {
        name: this.service.name,
        name_vi: this.service.name_vi,
        description: this.service.description,
        description_vi: this.service.description_vi,
        photo_url: this.service.photo_url,
        active: this.service.active
      }
      await this.$store.dispatch(`${SAVE_SERVICE}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/service')
        }
      });
    }
  }
}
</script>

<style scoped>

</style>